document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.plf');
  if (!root) return;

  const requestedVariantId = new URLSearchParams(window.location.search).get('variant');
  if (requestedVariantId) {
    window.setTimeout(() => {
      const requestedMotif = Array.from(root.querySelectorAll('.plf-cube')).find(
        (cube) => cube.dataset.vid === requestedVariantId
      );
      if (requestedMotif && !requestedMotif.classList.contains('on')) requestedMotif.click();
    }, 0);
  }

  root.classList.add('plf-cro');

  const title = root.querySelector('.plf-title');
  const lede = root.querySelector('.plf-lede');
  const addToPack = root.querySelector('#plf-add');
  const buyBox = root.querySelector('.plf-buy');
  const pack = root.querySelector('#plf-pk');
  const atc = root.querySelector('#plf-atc');
  const price = root.querySelector('#plf-pk-now');
  const trust = root.querySelector('.plf-trust');
  let mobileBarButton = null;

  if (title) title.textContent = 'Lot de 5 essuie-tout lavables épais — motifs chats';
  if (lede) lede.textContent = 'Choisissez votre motif, puis ajoutez votre lot au panier. Les boutons pression restent entièrement optionnels.';

  if (title && !root.querySelector('.plf-value-proof')) {
    const proof = document.createElement('div');
    proof.className = 'plf-value-proof';
    proof.innerHTML = '<strong><s>24,99 €</s> 19,99 € le lot de 5 — livraison offerte en France</strong><span>5 feuilles de 25 × 25 cm · matière épaisse 380 g/m² · lavables en machine</span>';
    title.after(proof);
  }

  const pills = root.querySelector('.plf-pills');
  if (pills) pills.innerHTML = '<span class="plf-pill">💧 Très absorbant</span><span class="plf-pill">🧵 380 g/m²</span><span class="plf-pill">🧺 Lavable</span>';

  const replacements = new Map([
    ['1. Choisis ton motif', '1. Choisissez votre motif'],
    ['Quel besoin résous-tu ?', 'Pourquoi passer au lavable ?'],
    ["Caspirolus t'accompagne au quotidien.", 'Caspirolus vous accompagne au quotidien.'],
    ['Choisis ton motif', 'Choisissez votre motif'],
    ['Utilise', 'Utilisez'],
    ['Lave', 'Lavez'],
    ['Réutilise', 'Réutilisez'],
    ['Rejoins le club Caspirolus', 'Rejoignez le club Caspirolus']
  ]);

  root.querySelectorAll('h2, h3, .plf-lbl, .plf-step h3, .plf-sub, .plf-nl h2').forEach((element) => {
    const replacement = replacements.get(element.textContent.trim());
    if (replacement) element.textContent = replacement;
  });

  root.querySelectorAll('.plf-sec').forEach((section) => {
    const heading = section.querySelector(':scope > .plf-h2');
    if (heading?.textContent.includes('Pourquoi passer au lavable')) section.classList.add('plf-redundant-section');
    if (section.querySelector('.plf-revs')) section.remove();
  });

  if (addToPack && buyBox && pack) {
    const actions = document.createElement('div');
    actions.className = 'plf-primary-actions';
    pack.before(actions);
    actions.append(buyBox, addToPack);
    addToPack.innerHTML = '<span class="ic">＋</span> Composer un pack';

    const promo = document.createElement('p');
    promo.className = 'plf-promo-note';
    promo.innerHTML = '−10 % avec le code <b>CASPIROLUS10</b> · remises pack automatiques';
    actions.after(promo);
  }

  if (trust) {
    trust.classList.add('plf-trust-priority');
    trust.innerHTML = '<span>🚚 Livraison offerte en France</span><span>📦 Suivi 2 à 5 jours ouvrés</span><span>🛡️ Satisfait ou remboursé 30 jours</span>';
    root.querySelector('.plf-primary-actions')?.after(trust);
  }

  if (atc && window.matchMedia('(max-width: 860px)').matches) {
    const mobileBar = document.createElement('div');
    mobileBar.className = 'plf-mobile-buybar';
    mobileBar.innerHTML = '<button type="button">Ajouter au panier — 19,99 €</button>';
    document.body.append(mobileBar);
    mobileBarButton = mobileBar.querySelector('button');
    mobileBarButton.addEventListener('click', () => {
      mobileBarButton.disabled = true;
      atc.click();
    });
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        mobileBar.hidden = entry.isIntersecting;
      }, { threshold: .35 });
      observer.observe(atc);
    }
  }

  const topBar = root.querySelector('.plf-bar');
  if (topBar) topBar.innerHTML = '<span>Livraison offerte en France</span><span class="c">−10 % avec CASPIROLUS10</span><span>Retours 30 jours</span>';

  const packTop = pack?.querySelector('.plf-pk-top');
  if (packTop && !pack.querySelector('.plf-pack-help')) {
    const help = document.createElement('div');
    help.className = 'plf-pack-help';
    help.innerHTML = '<strong>Mixez librement les motifs</strong>Ajoutez 2 lots pour économiser 10 €, ou 3 lots pour économiser 22,50 €.';
    packTop.after(help);
  }

  const packSteps = pack?.querySelectorAll('.plf-pk-steps span');
  if (packSteps?.length >= 3) {
    packSteps[0].textContent = '1 lot';
    packSteps[1].textContent = '2 lots = −10 €';
    packSteps[2].textContent = '3 lots = −22,50 €';
  }

  const getUnits = () => Array.from(pack?.querySelectorAll('.plf-pk-row .meta span') || []).reduce((sum, element) => sum + (element.textContent.includes('10 feuilles') ? 2 : 1), 0);
  const getSnapUnits = () => Array.from(pack?.querySelectorAll('.plf-pk-row .meta span') || []).reduce((sum, element) => {
    if (!element.textContent.toLowerCase().includes('pression')) return sum;
    return sum + (element.textContent.includes('10 feuilles') ? 2 : 1);
  }, 0);
  const formatEuro = (cents) => (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

  const refresh = () => {
    const units = getUnits();
    pack?.classList.toggle('plf-pack-empty', units === 0);
    const count = pack?.querySelector('.plf-pk-count');
    if (count) count.textContent = `${units} lot${units > 1 ? 's' : ''}`;

    if (units > 0 && price) {
      const discount = units >= 3 ? 2250 : units >= 2 ? 1000 : 0;
      price.textContent = formatEuro((1999 * units) - discount + (500 * getSnapUnits()));
    }

    if (atc) {
      const twoLots = root.querySelector('#plf-sheets button.on')?.dataset.mult === '2';
      const snaps = root.querySelector('#plf-snap button.on')?.dataset.snap === '1';
      let total = price?.textContent.trim() || '19,99 €';
      if (units === 0) total = twoLots ? (snaps ? '49,98 €' : '39,98 €') : (snaps ? '24,99 €' : '19,99 €');
      atc.textContent = `Ajouter au panier — ${total}`;
      if (mobileBarButton) mobileBarButton.textContent = atc.textContent;
    }

    root.querySelectorAll('#plf-sheets button, #plf-snap button, #plf-snap-color button').forEach((button) => button.setAttribute('aria-pressed', String(button.classList.contains('on'))));
  };

  root.addEventListener('click', (event) => {
    if (event.target.closest('#plf-sheets button, #plf-snap button, #plf-snap-color button, #plf-add, .plf-pk-row button')) window.setTimeout(refresh, 0);
    const faqButton = event.target.closest('#plf-faq .plf-q button');
    if (faqButton) window.setTimeout(() => faqButton.setAttribute('aria-expanded', String(faqButton.parentElement.classList.contains('open'))), 0);
    if (event.target.closest('.plf-cube')) window.setTimeout(() => configureGallery(true), 0);
  });

  if (atc) {
    atc.addEventListener('click', () => {
      atc.disabled = true;
      atc.setAttribute('aria-busy', 'true');
      if (mobileBarButton) mobileBarButton.disabled = true;
      window.setTimeout(() => {
        atc.disabled = false;
        atc.removeAttribute('aria-busy');
        if (mobileBarButton) mobileBarButton.disabled = false;
        refresh();
      }, 10000);
    });
  }

  root.querySelectorAll('.plf-cube').forEach((cube) => {
    cube.setAttribute('role', 'button');
    cube.setAttribute('tabindex', '0');
    cube.setAttribute('aria-label', `Choisir le motif ${cube.dataset.name}`);
    cube.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        cube.click();
      }
    });
  });

  const galleryOrders = {
    'Pirolus': [1, 3, 0, 4, 2],
    'Lavande': [0, 1, 2, 3],
    'Eucalyptus': [1, 2, 0, 3],
    'Maine Coon': [0, 2, 1, 3],
    'Persan': [1, 2, 3, 0],
    'Casper': [0, 1, 3, 2],
    'Grisou': [2, 0, 1],
    'Tigri': [2, 1, 0, 3]
  };

  const configureGallery = (selectFirst) => {
    const thumbs = root.querySelector('#plf-thumbs');
    const main = root.querySelector('#plf-main');
    const motif = root.querySelector('.plf-cube.on')?.dataset.name || 'Pirolus';
    if (!thumbs || !main) return;
    Array.from(thumbs.querySelectorAll('button')).forEach((button) => {
      const image = button.querySelector('img');
      if (image?.src.includes('width=180')) button.remove();
    });
    const buttons = Array.from(thumbs.querySelectorAll('button'));
    const order = galleryOrders[motif] || buttons.map((_, index) => index);
    const isNewMotif = thumbs.dataset.caspiMotif !== motif;
    if (isNewMotif) {
      const kept = new Set(order);
      buttons.forEach((button, index) => {
        if (!kept.has(index)) button.remove();
      });
      order.forEach((index) => {
        const button = buttons[index];
        if (button) thumbs.append(button);
      });
      thumbs.dataset.caspiMotif = motif;
    }
    Array.from(thumbs.querySelectorAll('button')).forEach((button, index) => {
      button.setAttribute('aria-label', `Afficher ${motif}, vue ${index + 1}`);
      const image = button.querySelector('img');
      if (image) {
        image.alt = `${motif}, vue ${index + 1}`;
        image.loading = 'lazy';
        image.decoding = 'async';
      }
    });
    main.alt = `${motif} — essuie-tout lavable Caspirolus`;
    main.decoding = 'async';
    main.sizes = '(max-width: 860px) 100vw, 50vw';
    if (selectFirst && isNewMotif) thumbs.querySelector('button')?.click();
  };

  const mainFrame = root.querySelector('#plf-main')?.closest('.main');
  if (mainFrame) {
    let startX = 0;
    let startY = 0;
    mainFrame.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    mainFrame.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (!touch) return;
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      const buttons = Array.from(root.querySelectorAll('#plf-thumbs button'));
      const current = Math.max(0, buttons.findIndex((button) => button.classList.contains('on')));
      const next = (current + (dx < 0 ? 1 : -1) + buttons.length) % buttons.length;
      buttons[next]?.click();
    }, { passive: true });
  }

  root.querySelectorAll('#plf-faq .plf-q button').forEach((button) => button.setAttribute('aria-expanded', 'false'));
  root.querySelector('#plf-pk-now')?.setAttribute('aria-live', 'polite');
  root.querySelector('#plf-toast')?.setAttribute('aria-live', 'polite');

  const guarantee = root.querySelector('.plf-guar');
  if (guarantee) {
    const heading = guarantee.querySelector('h2');
    const paragraph = guarantee.querySelector('p');
    if (heading) heading.textContent = 'Satisfait ou remboursé 30 jours';
    if (paragraph) paragraph.textContent = 'Essayez Caspirolus sereinement. Si le produit ne vous convient pas, contactez-nous sous 30 jours afin que nous trouvions une solution.';
  }

  const faqAnswers = root.querySelectorAll('#plf-faq .plf-q .a');
  if (faqAnswers.length) faqAnswers[faqAnswers.length - 1].textContent = 'Livraison offerte en France, avec suivi. Comptez généralement 2 à 5 jours ouvrés après expédition.';

  const newsletter = root.querySelector('.plf-nl');
  if (newsletter) {
    const heading = newsletter.querySelector('h2');
    const paragraph = newsletter.querySelector('p');
    const input = newsletter.querySelector('input[type="email"]');
    if (heading) heading.textContent = 'Rejoignez le club Caspirolus';
    if (paragraph) paragraph.innerHTML = 'Recevez les nouveaux motifs et profitez de <strong>10 % de réduction</strong> avec CASPIROLUS10.';
    if (input) input.placeholder = 'Votre e-mail';
  }

  const amazon = root.querySelector('.plf-amz');
  if (amazon) {
    amazon.classList.add('plf-amz-deferred');
    (newsletter || root.lastElementChild)?.after(amazon);
  }

  configureGallery(true);
  window.setTimeout(() => configureGallery(false), 300);
  window.setTimeout(() => configureGallery(false), 900);
  refresh();
});
